import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
export var Provider = function Provider(_ref) {
  var context = _ref.context,
    children = _ref.children;
  return /*#__PURE__*/_jsx(ReduxProvider, {
    store: context.store,
    children: React.Children.only(children)
  });
};